import {lazy} from 'react';

export const ResetPasswordPageAsync = lazy(() =>
    import('./ResetPasswordPage')
);
